function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.4,
  d: "M16 2H8C4 2 2 4 2 8V21C2 21.55 2.45 22 3 22H16C20 22 22 20 22 16V8C22 4 20 2 16 2Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5514 7.46001C15.2914 6.20001 14.0714 6.17001 12.7814 7.46001L11.9914 8.25001C11.9214 8.32001 11.9014 8.42001 11.9214 8.51001C12.4114 10.23 13.7814 11.6 15.5014 12.09C15.5214 12.1 15.5514 12.1 15.5814 12.1C15.6514 12.1 15.7214 12.07 15.7714 12.02L16.5514 11.24C17.1914 10.6 17.5014 9.99001 17.5014 9.37001C17.5014 8.72001 17.1914 8.10001 16.5514 7.46001Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.3404 12.67C14.1504 12.58 13.9704 12.49 13.8004 12.38C13.6604 12.3 13.5204 12.21 13.3904 12.11C13.2804 12.04 13.1504 11.94 13.0204 11.83C13.0004 11.82 12.9604 11.79 12.9104 11.73C12.7004 11.55 12.4604 11.31 12.2404 11.06C12.2204 11.05 12.1904 11 12.1504 10.94C12.0804 10.86 11.9804 10.73 11.8804 10.59C11.8004 10.49 11.7104 10.35 11.6304 10.21C11.5304 10.04 11.4304 9.86 11.3504 9.68C11.2604 9.48 11.1904 9.3 11.1204 9.12L7.35044 12.89C7.10044 13.14 6.87044 13.6 6.82044 13.94L6.53043 16.02C6.46043 16.46 6.59042 16.87 6.86042 17.15C7.09042 17.38 7.41044 17.5 7.76044 17.5C7.84044 17.5 7.91042 17.49 7.99042 17.48L10.0704 17.19C10.4104 17.14 10.8704 16.91 11.1204 16.66L14.8904 12.89C14.7104 12.82 14.5304 12.75 14.3404 12.67Z",
  fill: "white",
  fillOpacity: 0.4
});

var SvgPlaceOrderDark = function SvgPlaceOrderDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlaceOrderDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PlaceOrder_dark.084f647e.svg";
export { ForwardRef as ReactComponent };